import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import Home from './pages/Home';
import Listing from './pages/Listing';
import LawFirmDetail from './pages/LawFirmDetail';
import Cities from './pages/Cities';
import Categories from './pages/Categories';
import Articles from './pages/Articles';
import ArticleDetail from './pages/ArticleDetail';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import AIMatch from './pages/AIMatch';
import LongTailLanding from './pages/LongTailLanding';
import RescissionCalculator from './pages/RescissionCalculator';
import RetirementCalculator from './pages/RetirementCalculator';
import Plans from './pages/Plans';
import Checkout from './pages/Checkout';
import ClaimProfile from './pages/ClaimProfile';
import Admin from './pages/Admin';
import Header from './components/Header';
import Footer from './components/Footer';
import { Toaster } from './components/ui/toaster';

function ScrollToTop() {
  const { pathname, search, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) { el.scrollIntoView(); return; }
    }
    window.scrollTo(0, 0);
  }, [pathname, search, hash]);
  return null;
}

function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <ScrollToTop />
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <AuthProvider>
          <BrowserRouter>
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/match" element={<AIMatch />} />
                <Route path="/simulador/rescisao" element={<RescissionCalculator />} />
                <Route path="/simulador/aposentadoria" element={<RetirementCalculator />} />
                <Route path="/advogados" element={<Listing />} />
                <Route path="/cidade/:citySlug" element={<Listing />} />
                <Route path="/categoria/:catSlug" element={<Listing />} />
                <Route path="/advogado/:catSlug/em/:citySlug" element={<LongTailLanding />} />
                <Route path="/escritorio/:slug" element={<LawFirmDetail />} />
                <Route path="/cidades" element={<Cities />} />
                <Route path="/categorias" element={<Categories />} />
                <Route path="/artigos" element={<Articles />} />
                <Route path="/artigo/:firmSlug/:articleId" element={<ArticleDetail />} />
                <Route path="/login" element={<Login />} />
                <Route path="/cadastro" element={<Register />} />
                <Route path="/painel" element={<Dashboard />} />
                <Route path="/planos" element={<Plans />} />
                <Route path="/checkout/:planId" element={<Checkout />} />
                <Route path="/reivindicar/:slug" element={<ClaimProfile />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
            </Layout>
          </BrowserRouter>
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
